import React from "react";
import Header from "../../../../components/header";
import useManageGeneralChart from '../hooks/use-manage-general-chart';
import { ChartTypeEnum } from '../../../../models/chart';

const ManageGeneralChartHeader = () => {
  const { mode } = useManageGeneralChart(ChartTypeEnum.GENERAL_ELECTION);
  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            {`${mode === 'create' ? 'Create' : 'Edit'} General Election Test Chart`}
          </div>
        </div>
      </Header>
    </>
  );
};

export default ManageGeneralChartHeader;
